class FetchError {
  constructor(status, message) {
    this.status = status;
    this.message = message;
  }
}

export default FetchError;
